import { useTranslation } from "react-i18next";
import { Col, Row } from 'react-bootstrap';
import PageTitle from "../../../layouts/PageTitle";
import PayableReceivableHistory from "../../../components/Custom/CashFlow/PayableReceivable/PayableReceivableHistory";

const PayableReceivableCashFlowList = () => {

    const { t } = useTranslation();

    return (
        <>
            <PageTitle activeMenu={t('cash_flow.accounts_payable_receivable')} motherMenu={t('cash_flow.label')} />
            <Row>
                <Col className="col-md-12">
                    <PayableReceivableHistory/>
                </Col>
            </Row>
        </>
    );
}

export default PayableReceivableCashFlowList;